import  {Component} from 'react';
import axios from "axios";
import {apiConfigs,headers } from '../Config';



class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 10000;
    }

    // Login Page
    signUp = (mobile , reagent_code = null) =>{
       return  axios.post( 'sign-up', {mobile, reagent_code}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Verify OTP Page
    signIn = (mobile , otp) =>{
       return  axios.post( 'sign-in', {mobile , otp}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //  Register Page
    //  Register Page
    updateProfile = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( 'users/update-profile', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getUserInfo = (params = null) => {
        return axios.get( `users/profiles/info`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getContent = (slug) => {
        return axios.get( `contents/${slug}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    //Home Page

    getServiceGroups = (params) => {
        return axios.get( `services/groups`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getServitorCompanies = (params = null) => {
        return axios.get( `services/servitor-companies`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getServitorCompany = (id,params) => {
        return axios.get( `services/servitor-companies/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    //Set Request Options Page
    getAddresses = (params = null) => {
        return axios.get( `addresses`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    storeRequest = (request) =>{
        return  axios.post( 'service-requests', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
//Add Address
    storeAddress = (request) =>{
        return  axios.post( 'addresses', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Requests History Page
    getRequests = (params = null) => {
        return axios.get( `service-requests`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    //Request Page
    getRequest = (params = null , id) => {
        return axios.get( `service-requests/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getServices = (params = null) => {
        return axios.get( `services/services`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Payment
    getBankURL = (request) =>{
        return  axios.post( 'payments/generate-bank-url', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    saveRate = (request) =>{
        return  axios.post( 'request-rate', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    savePayment = (request) =>{
        return  axios.post( 'payments/save', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    sendInviteSMS = (request) =>{
        return  axios.post( 'users/invite-sms', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getSlides = (params = null) => {
        return axios.get( `slideshows`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getWalletDetail = (params = null) => {
        return axios.get( `wallets/transactions`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

}
const API = new Api();
export default API;